import React from "react";
import {
  Typography,
  Card,
  Avatar,
  Divider,
} from "@material-ui/core";
import { AvatarGroup } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core";

import Logo from "../../../getKampus.png";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    // borderLeft: "1px solid darkblue",
    paddingLeft: theme.spacing(1),
    height: "85vh",
    display: "flex",
    flexDirection: "column",
    // paddingTop: theme.spacing(2),
  },
  infoCard: {
    //marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    borderRadius: "0px 10px 0px 0px",
  },
  avatar: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    // padding: theme.spacing(3),
    // backgroundColor: "blue"
  },
  activeUsersCard: {
    marginBottom: theme.spacing(2),
  },
  usersInGroupCard: {
    marginBottom: theme.spacing(2),
  },
  avatarContent: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export default function UserProfile() {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Card className={classes.infoCard}>
        <Avatar src={Logo} className={classes.avatar} />

        <Typography variant="h6" align="center">
          National University of Singapore
        </Typography>
      </Card>
      <Card className={classes.activeUsersCard}>
        <Typography
          variant="h6"
          align="center"
          gutterBottom
          style={{ paddingTop: 5 }}
        >
          Active Users
        </Typography>
        <Divider />

        <AvatarGroup max={4} className={classes.avatarContent}>
          <Avatar src={Logo} />
          <Avatar src={Logo} />
          <Avatar src={Logo} />
          <Avatar src={Logo} />
          <Avatar src={Logo} />
        </AvatarGroup>
      </Card>
      <Card className={classes.usersInGroupCard}>
        <Typography
          variant="h6"
          align="center"
          gutterBottom
          style={{ paddingTop: 5 }}
        >
          Users in Group
        </Typography>
        <Divider />

        <AvatarGroup max={4} className={classes.avatarContent}>
          <Avatar src={Logo} />
          <Avatar src={Logo} />
          <Avatar src={Logo} />
          <Avatar src={Logo} />
          <Avatar src={Logo} />
        </AvatarGroup>
      </Card>
    </div>
  );
}
